import React from "react";
import Footer from "../../components/Layout/Footer";
import SearchModal from "../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../components/Common/ScrollTop";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import AboutMain from "./AboutMain";
// import Loader from "../../Loader";

import bannerbg from "../../assets/img/breadcrumbs/1.jpg";
import CounterStyleThree from "../../components/Elements/Counter/CounterStyleThree";

const About = () => {
  //   const [loading, setLoading] = useState(true);

  //   useEffect(() => {
  //     const timer = setTimeout(() => {
  //       setLoading(false);
  //     }, 1500);

  //     return () => clearTimeout(timer);
  //   }, []);

  return (
    <React.Fragment>
      {/* {loading ? (
                <Loader />
            ) : ( */}
      <>
        <main>
          <SiteBreadcrumb
            pageTitle="About Us"
            titleClass="page-title"
            pageName="About"
            breadcrumbsImg={bannerbg}
          />

          <AboutMain />

          <ScrollToTop />
        </main>
        <CounterStyleThree />
        <Footer />

        <SearchModal />
      </>
      {/* )} */}
    </React.Fragment>
  );
};

export default About;
